export const windowWidth = window.innerWidth;
export const windowHeight = window.innerHeight;

declare global {
  interface Window {
    resetEvent: Event;
    popupsClosedEvent: Event;
    popupOpenEvent: Event;
    qtyChangeEvent: Event;
    resetQtyEvent: Event;
    itemsLoadedEvent: Event;
  }
}
export function addEvent() {
  window.resetEvent = new Event('reset');
  window.popupsClosedEvent = new Event('popupsClosed');
  window.popupOpenEvent = new Event('popupOpen');
  window.qtyChangeEvent = new Event('qtyChange');
  window.resetQtyEvent = new Event('resetQty');
  window.itemsLoadedEvent = new Event('itemsLoaded');
}
export function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${windowHeight}px`);
}

export function heightChange() {
  window.addEventListener('resize', appHeight);
}

export function isInViewFull(el: HTMLElement) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= windowHeight;
}

export function isInView(el: HTMLElement) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.top <= windowHeight;
}

export function scrollIntoView(el: HTMLElement, offset: number) {
  const scroll = el.getBoundingClientRect().top + window.scrollY - offset;
  window.scroll({
    top: scroll,
    behavior: 'smooth',
  });
}

export function formattPrice(price: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
}

export enum ShowHide {
  SHOW_MORE = 'SHOW MORE',
  SHOW_LESS = 'SHOW LESS',
}
